<template>
    <div class="p-d-16">
        <SOSlotCard
            card-type="shadow"
        >
            <template v-slot:card_head>
                <div class="mt-2 d-flex-between-center">
                    <span>{{ data.id }}</span>
                </div>
            </template>
            <template v-slot:card_body>
                <div>
                    <div class="f-c-midgrey">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="#C8D0DD" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M6 6H6.00667" stroke="#C8D0DD" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M10 6H10.0067" stroke="#C8D0DD" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M10.6667 8.66663H5.33337M5.33337 8.66663C5.33337 9.37387 5.61433 10.0521 6.11442 10.5522C6.61452 11.0523 7.2928 11.3333 8.00004 11.3333C8.70728 11.3333 9.38556 11.0523 9.88566 10.5522C10.3858 10.0521 10.6667 9.37387 10.6667 8.66663H5.33337Z" stroke="#C8D0DD" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span class="pl-1">{{ data.customer_global.nama_awal }} {{ data.customer_global.nama_akhir }}</span>
                    </div>
                    <div class="d-flex">
                        <div class="f-c-midgrey p-r-12">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.33325 8.66675V3.66675C5.33325 3.40153 5.43861 3.14718 5.62615 2.95964C5.81368 2.7721 6.06804 2.66675 6.33325 2.66675C6.59847 2.66675 6.85282 2.7721 7.04036 2.95964C7.2279 3.14718 7.33325 3.40153 7.33325 3.66675V8.00008" stroke="#C8D0DD" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M7.33325 3.66671V2.33337C7.33325 2.20205 7.35912 2.07202 7.40937 1.95069C7.45963 1.82936 7.53329 1.71913 7.62614 1.62627C7.719 1.53341 7.82924 1.45975 7.95057 1.40949C8.07189 1.35924 8.20193 1.33337 8.33325 1.33337C8.46457 1.33337 8.59461 1.35924 8.71594 1.40949C8.83726 1.45975 8.9475 1.53341 9.04036 1.62627C9.13322 1.71913 9.20688 1.82936 9.25713 1.95069C9.30739 2.07202 9.33325 2.20205 9.33325 2.33337V8.00004" stroke="#C8D0DD" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.33325 3.66675C9.33325 3.40153 9.43861 3.14718 9.62615 2.95964C9.81368 2.7721 10.068 2.66675 10.3333 2.66675C10.5985 2.66675 10.8528 2.7721 11.0404 2.95964C11.2279 3.14718 11.3333 3.40153 11.3333 3.66675V8.00008" stroke="#C8D0DD" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.3332 5C11.3332 4.73478 11.4386 4.48043 11.6261 4.29289C11.8136 4.10536 12.068 4 12.3332 4C12.5984 4 12.8528 4.10536 13.0403 4.29289C13.2279 4.48043 13.3332 4.73478 13.3332 5V10.6667C13.3332 11.7275 12.9118 12.7449 12.1616 13.4951C11.4115 14.2452 10.3941 14.6667 9.33321 14.6667H7.99988H8.13854C7.4761 14.6668 6.824 14.5024 6.2408 14.1882C5.6576 13.874 5.16155 13.4199 4.79721 12.8667C4.75348 12.8001 4.70993 12.7334 4.66654 12.6667C4.45854 12.3473 3.72854 11.0747 2.47588 8.848C2.34818 8.62102 2.31407 8.35318 2.3808 8.10143C2.44753 7.84969 2.60984 7.63392 2.83321 7.5C3.07113 7.35724 3.34993 7.29808 3.62532 7.3319C3.90071 7.36572 4.1569 7.49058 4.35321 7.68667L5.33321 8.66667" stroke="#C8D0DD" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="pl-1" v-if="data.jenis == 2">Drop Off</span>
                            <span class="pl-1" v-if="data.jenis == 1">Self Service</span>
                        </div>
                        <div>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.364 5.23415L12.9591 2.99146C12.8335 2.79014 12.6106 2.66675 12.3724 2.66675H3.6268C3.38868 2.66675 3.16571 2.79014 3.04015 2.99146L1.63522 5.23415C0.910027 6.3923 1.55296 8.00288 2.9081 8.18689C3.00552 8.19988 3.10509 8.20637 3.20467 8.20637C3.84544 8.20637 4.41261 7.92495 4.80227 7.48983C5.19192 7.92495 5.76126 8.20637 6.39986 8.20637C7.04063 8.20637 7.6078 7.92495 7.99745 7.48983C8.38711 7.92495 8.95644 8.20637 9.59505 8.20637C10.2358 8.20637 10.803 7.92495 11.1926 7.48983C11.5845 7.92495 12.1516 8.20637 12.7902 8.20637C12.892 8.20637 12.9894 8.19988 13.0868 8.18689C14.4463 8.00505 15.0914 6.39447 14.364 5.23415ZM12.7946 8.90126C12.5781 8.90126 12.3638 8.86879 12.156 8.819V10.9794H3.84328V8.819C3.63546 8.86662 3.42115 8.90126 3.20467 8.90126C3.07479 8.90126 2.94274 8.8926 2.81502 8.87528C2.69379 8.85796 2.57473 8.82982 2.46 8.79735V13.0576C2.46 13.4408 2.76956 13.7503 3.15272 13.7503H12.8508C13.234 13.7503 13.5436 13.4408 13.5436 13.0576V8.79735C13.4267 8.83199 13.3098 8.86013 13.1885 8.87528C13.0565 8.8926 12.9266 8.90126 12.7946 8.90126Z" fill="#C8D0DD"/>
                            </svg>
                            <span class="pl-1">{{ data.outlet.nama }}</span>
                        </div>
                    </div>
                    <div class="f-c-midgrey">
                        Diterima: {{ $moment(data.created_at).format("DD MMM YYYY") }}
                    </div>
                </div>
            </template>
            <template v-slot:card_footer>
                <div class="d-flex-between-center c-foot">
                    <div class="">
                        <p class="m-d-0 f-14 f-semi">
                            {{ data.grandtotal | currency }}
                            <label class="lunas" v-if="data.lunas == 1">Lunas</label>
                            <!-- <label class="" v-if="data.lunas == 0">Belum Lunas</label>  -->
                        </p>
                    </div>
                    <div v-if="data.status == 0">
                        <span class="m-d-0 f-12 f-c-midgrey">Belum Jalan</span>
                    </div>
                    <div v-if="data.status == 1">
                        <span class="m-d-0 f-12 f-c-midgrey">Sedang berjalan</span>
                    </div>
                    <div v-if="data.status == 2">
                        <span class="m-d-0 f-12 f-c-midgrey">Selesai</span>
                    </div>
                </div>
            </template>
        </SOSlotCard>
    </div>
</template>

<script>
import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

export default {
    name:"CardTransaksiHapus",
    components: {
        SOSlotCard,
    },
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        
    },
}
</script>

<style scoped>
.c-foot p label {
    padding: 2px 8px;
    margin: 0px 4px;
    border-radius: 50px;
    background-color: pink;
}
.c-foot .lunas {
    background-color: #effaf1;
    color: #40964c;
}
</style>